import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PressItem from '../elements/press_item.js';
import kit from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_kit.png';
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";
import { Player } from 'video-react';



class Press extends Component {
  constructor(props) {
    super(props);
    this.visitYahooFin = this
        .visitYahooFin
        .bind(this);
}
  press_data = [
    {"id": 1,
      "title": "Wellness Matrix Addresses OTC Caveat Emptor Issue",
    "link":"https://finance.yahoo.com/news/wellness-matrix-addresses-otc-caveat-155252056.html",
    "date":"August 9, 2019",
    "teaser":"Wellness Matrix (OTC PINK: WMGR) today announced that the company's status of its Caveat Emptor label is being addressed. Wellness Matrix understands that this is a safety measure for OTC Markets to protect the public...",    
    },
    {"id":2,
      "title": "Wellness Matrix Starts Testing Artificial Intelligence to Produce High Revenue From Customers’ Health Analysis",
    "link":"https://finance.yahoo.com/news/wellness-matrix-starts-testing-artificial-151209080.html",
    "date":"July 16, 2019",
    "teaser":"Wellness Matrix Group, Inc. (WMGR) announced today the commencement of beta testing on their marketing and sales website prototype designed to incorporate, upon test completion, an interactive Marketing Program designed to target websites already possessing substantial numbers of visitors interested in improving their health...",    
    },
    {"id":3,
    "title": "Wellness Matrix Group Appoints David Saltrelli Vice President of Marketing",
    "link":"https://finance.yahoo.com/news/wellness-matrix-group-appoints-david-120000092.html",
    "date":"May 29, 2019",
    "teaser":"Wellness Matrix Group, Inc. (WMGR) announced today that branding, incentives, marketing, and sales expert David Saltrelli was appointed Vice President of Marketing...",    
    },
    {"id":4,
    "title": "The Wellness Matrix Group Names Joshua Patterson President",
    "link":"https://finance.yahoo.com/news/wellness-matrix-group-names-joshua-120000011.html",
    "date":"May 07, 2019",
    "teaser":"Wellness Matrix Group, Inc. (WMGR), today announced that its board of directors has appointed the highly accomplished senior software engineer in enterprise solutions, Joshua Patterson, as President. Mr. Patterson has more than 15 years of experience involving healthcare, finance, and operations...",    
    },
    {"id":5,
    "title": "Wellness Matrix Group To Initiate State-of-the-Art DNA Program",
    "link":"https://www.globenewswire.com/news-release/2019/03/01/1745243/0/en/Wellness-Matrix-Group-To-Initiate-State-of-the-Art-DNA-Program.html",
    "date":"March 01, 2019",
    "teaser":"Wellness Matrix Group, Inc. (WMGR), a technologically advanced Company in the Virtual Reality Artificial Intelligence health care model space, released details today on its DNA program initiative which will serve as Wellness Matrix Group’s strategic point of public engagement in their enhanced wellness space...",    
    },

    {"id":6,
    "title": "Wellness Matrix Group To Initiate State-of-the-Art Wellness Model Program",
    "link":"https://www.globenewswire.com/news-release/2019/01/17/1701259/0/en/Wellness-Matrix-Group-To-Initiate-State-of-the-Art-Wellness-Model-Program.html",
    "date":"January 17, 2019",
    "teaser":"Wellness Matrix Group, Inc. (OTC:WMGR) announces today that it will shortly introduce what it considers the world's most technologically advanced health care models in Virtual Reality Artificial Intelligence. Incorporated in this development is the Best of the Best Doctors, and methodologies with Genome analysis, monitoring, and predictive modeling simulation. The result is the state-of-the-art Wellness Matrix Program for Quality of Life and Longevity...",    
    },
  ];
  visitYahooFin(){
    console.log('yahoo');
    window.open(
      'https://finance.yahoo.com/quote/wmgr/',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  items = this.press_data.map(item => {
    return <PressItem 
        key={item.id}
        title={item.title}
        link={item.link}
        date={item.date}
        teaser={item.teaser}
        />
  });
  //<img className="content_image" src={kit}/>
  render() {
    return (
        <div>
          <div className="container mit">
            <div className="container_message" >
            <div className="content_text_title">Press Releases</div>
            <div className="content_text">
              Learn more about our press releases and market information at Yahoo Finance.            
            </div> 
            
              {/* <Button className="button_learn_more" intent="primary" icon="chevron-right"  onClick={this.visitYahooFin}>Learn More</Button> */}
              
            </div>
          </div>

          <div className="flex_container">
            <ul className="flex-grid-thirds press_container">
                {this.items}
            </ul>
        </div>

        <div className="banner_callout light"><div className="banner_callout_text">

        <div>
        Investor Relations:
            Michael Selsman: www.publiccommunicationsco.com - 310-553-5732
        </div>
                 
        
        </div></div>

    </div>
    );
  }
}

export default Press;